export default "__VITE_ASSET__Ccw3jmgw__"